export const checkIfElementInViewport = (element) => {
  const rect = document.querySelector(element).getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  return rect.top <= windowHeight && rect.top + rect.height >= 0;
};
